module.exports = __webpack_public_path__ + "img/whrp.21593d3e.png";